import React, { Component } from 'react';
import Sidebar from './Sidebar';
import store from "../../../store";
import { connect } from 'react-redux';
import { createTicket, getTickets, getIssueTypes } from "../../../actions/jobseekerAction";
import { translate } from 'react-multi-lang'
import Validation from "../../hoc/Validation";
import { chunk, getTimeWithAmPm } from '../../../helpers'
import Pagination from "react-js-pagination";
import { Link } from 'react-router'
import { gethireme } from '../../../actions/accountAction';

const RESULT_PER_PAGE = 25

class HireMee extends Component {

    constructor(props) {
        super(props);
        this.state = {
            formData: [],
            submit: false,
            activePage: 1,
            ticket: []
        }
        this.confirmBox = React.createRef()
        store.dispatch(getTickets())
        store.dispatch(getIssueTypes())
    }

    handlePageChange = (activePage) => {
        this.setState({ activePage: activePage })
    }

    handleInputs = async (e) => {
        const name = e.target.name;
        const value = e.target.value;
        let formData = this.state.formData;
        formData[name] = value;
        await this.setState({ formData, submit: false });
    }

    componentDidMount() {
        document.title = this.props.t('hireme.pageTitle', { param: 'react' })
    }

    submit = async (e) => {
        e.preventDefault();
        if (!this.props.validator.allValid() && !this.state.submit) {
            // store.dispatch(createTicket(this.state.formData)) 
            this.props.validator.showMessages();
            this.forceUpdate();
        }
    }

    confirmSubmit = () => {
        this.confirmBox.current.click()
        store.dispatch(createTicket(this.state.formData))
        this.props.validator.hideMessages()
        this.setState({ formData: [], submit: true })
    }

    getTimeInfo = (time) => {
        if (time) {
            let splitTime = time.split(' ')
            splitTime = getTimeWithAmPm(splitTime[1])
            return splitTime
        }
    }

    
  handleSubmitHireme() {
    if (localStorage.getItem("token") !== "NULL") { 
      store.dispatch(
        gethireme({
          auth_key: localStorage.getItem("token"),
          NCSPID: "J10H74-1551166999727",
        }, "hiremee/index")
      ); 
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else { 
      this.forceUpdate();
    }
  }

    render() {
        let Mainprops = this.props;
        const { validator } = this.props
        const { formData, activePage, ticket } = this.state
        const Mainthis = this

        if (localStorage.getItem('Islogin') !== 'true') {
            this.props.router.push('/');
        }

        let searchResults = chunk(Mainprops.JobseekerReducer.tickets, RESULT_PER_PAGE)
        const issueType = this.props.JobseekerReducer.issueTypes

        return (
            <section className="back-dashboard widget-sidebar-context mt-3" id="my-sidebar-context">
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        {Sidebar ? <Sidebar route={Mainprops.route} /> : ''}
                        <div className="modal fade" ref={this.confirmBox} id="confirmBox" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h6 className="modal-title" id="exampleModalLabel">{this.props.t('JobPost.ticketConfirm', { param: 'react' })}</h6>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-footer">
                                        <button aria-label="Yes" type="button" className="btn btn-primary btn-primary2" onClick={this.confirmSubmit}>{this.props.t('profileDetails.yes', { param: 'react' })}</button>
                                        <button aria-label="No" type="button" className="btn btn-primary btn-primary2" data-dismiss="modal">{this.props.t('profileDetails.no', { param: 'react' })}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="clearfix"></div>
                            <div className="tab-content">
                                <div id="home" className=" tab-pane active">
                                    <section className="login-form mt-0">
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-sm-12 col-lg-12 bg-education mx-auto p-0">
                                                    <div className="panel-heading">
                                                        <h6 className="mb-0">{this.props.t('hireme.pageHeading' )}</h6>
                                                    </div>
                                                    <div className="panel-body hireMeSec">
                                                        
                                                        <p>National Career Service (NCS) Portal now offers <b>“Employability Assessment”</b> by HireMee free of cost for its registered Jobseekers. </p>

                                                        <h3>Test Name:</h3>
                                                     
                                                        <p>Employability Assessment</p>

                                                        <h3>About this Test:</h3>
                                                        
                                                        <p><b>Employability Assessment </b> is an AI proctored free evaluation tool that has helped more than 220,000 students get opportunities from top corporates over the past few years. More than 630,000 students have successfully completed this assessment till date. It’s a 100-minute exam that includes psychometric, communication skills, verbal ability, logical reasoning, domain knowledge & computer skills.</p>
                                                      
                                                        <p>Some of the top corporates who have been leveraging this platform for hiring are Bosch, LG Soft, Flipkart, Jindal, Yes Bank etc. to name a few.</p>
                                                        
                                                        <h3>Key Benefits:</h3>
                                                        <ul className='ps-3'>
                                                            <li>Students get a view of their employability quotient. </li>
                                                            <li>Get noticed by dream employers. </li>
                                                            <li>Identify strengths and areas of improvements. </li>
                                                            <li>Stand out in the crowd by posting your video resumes. </li>
                                                            <li>Accessible on app and web platforms. </li>
                                                            <li>Instant test results. </li>
                                                        </ul>

                                                        <b>You need to Register/Login to take the test.</b>
                                                    
                                                        <p>
                                                            <a 
                                                            aria-label="Click here to take the test"
                                                            href="#" onClick={this.handleSubmitHireme} className="ncs-click-log">
                                                                <div>
                                                                    Click here to take the test
                                                                </div>
                                                            </a>
                                                        </p>


           
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div> 
                           
                        </main>
                    </div>
                </div>
            </section>)
    }
}

const mapStateToProps = store => {
    return store;
};
export default connect(mapStateToProps)(translate(Validation(HireMee)));
